import "./App.css";
import React, { useState } from "react";
import FAQ from './component/Utilities';
import './css/faq.css'
import Navigation from "./component/Navigation";
import Footer from "./component/Footer";
import fast from "./images/speedo-bk.png";
import security from "./images/shield-bk.png";
import prices from "./images/dollar-bk.png";
import support from "./images/headset-bk.png";
import server from "./images/servers-bk.png";
import smile from "./images/smiley-bk.png";
import gear from "./images/gear-bk.png";
import mc from "./images/mc.jpg";
// import PriceCard from "./component/PriceCard";
import Card from "./component/Card";


function App() {
    document.title = 'Novu Servers'
    const [faqs, setfaqs] = useState([
        {
          question: 'Hvor kører jeres server henne?',
          answer: 'Alle vores servere køre i Falkenstein i Tyskland.',
          open: false
        },
        {
          question: 'Har i tilfredshedsgaranti?',
          answer: 'På nuværende tidspunkt tilbyder vi ikke tilfredshedsgaranti',
          open: false
        },
        {
          question: 'Hvad er "Managed" hosting?',
          answer: "Managed hosting er hvor du som kunde betaler et lidt højere gebyr for tilgengæld at have udvidet support adgang. Dette gør at vi går den ekstra meter for at finde en løsning til dig og sikrer at du altid får hurtigt svar. \n Denne løsning er ideel hvis du er ny til spil servere eller har behov for hjælp til det tekniske bag server drift. \n Er du i tvivl om denne løsning er noget for dig kan du kontakte os via følgende link: {indsæt link her}",
          open: false
        },
        {
          question: 'Hvad er "Unmanaged" hosting?',
          answer: 'Unnanaged hosting er hvor du som kunde selv styre din server 100% selv og ikke vil modtage nogen former for support. \n Denne løsning er ideel hvis du er dygtigt til serverdrift og kan klare det meste selv. \n Er du i tvivl om denne løsning er noget for dig kan du kontakte os via følgende link: {indsæt link her}',
          open: false
        }
      ]);
    
      const toggleFAQ = index => {
        setfaqs(faqs.map((faq, i) => {
          if (i === index) {
            faq.open = !faq.open
          } else {
            faq.open = false;
          }
    
          return faq;
        }))
      }

    return (
        <div>
            <div classname="pageContainer">
                <div className="ContentWarp">
                    <Navigation />
                    <div className="image-box-container">
                        <div className="clip1">
                            <div class="image-box-content">
                                <h2>Counter Strike Global Offensive (CSGO) servere</h2>
                                <p>Vi tilbyder en række muligheder til hosting af CSGO servere i forskellige størrelser og til forskellige priser. Læs mere om mulighederne her "link". </p>
                            </div>
                        </div>
                        <div className="clip clip2">
                            <div class="image-box-content">
                                <h2>Minecraft servere</h2>
                                <p>Vi tilbyder en bred vifte af server løsninger til forskellige Minecraft server typer i forskellige størrelser. Dette inkludere alt fra modded Minecraft til større Minecraft server netværk som "BungeeCord". Læs mere om mulighederne her "link".</p>
                            </div>
                        </div>
                        <div className="clip clip3">
                            <div class="image-box-content">
                                <h2>Valheim servere</h2>
                                <p>Vi tilbyder Valheim server hosting i en række forskellige størrelser som kan tilpasses til dit enkelte budget og behov.</p>
                            </div>
                        </div>
                        <div className="clip clip4">
                            <div class="image-box-content">
                                <h2>Rust servere</h2>
                                <p>Vi tilbyder Rust sever hosting med adskillige størrelser af hukummelse, som dermed kan jursteres til ens personlige be </p>
                        </div>
                        </div>
                        <div className="clip clip5">
                        <div class="image-box-content">
                                <h2>Meget Mere</h2>
                                <p>Vi tilbyder også servers til en helt masse andre spil. </p>
                        </div>
                        </div>

                    </div>
                    <div className="grid">
                        <Card image="rust-logo" text1="Rust" text2="Hvad vi tilbyder" textinfo1="2 GB ram for god start" textinfo2="3 GB ram for en bedre start" textinfo3="5 GB ram for fantastisk start" background_color="#b7410e" square_color="#494949" />
                        <Card image="diamond_sword" text1="Minecraft" text2="Hvad vi tilbyder"  textinfo1="2 GB ram for god start" textinfo2="3 GB ram for en bedre start" textinfo3="5 GB ram for fantastisk start" background_color="#72b147" square_color="#494949" />
                        <Card image="CSGO_logo" text1="CSGO" text2="Hvad vi tilbyder" textinfo1="2 GB ram for god start" textinfo2="3 GB ram for en bedre start" textinfo3="5 GB ram for fantastisk start" background_color="#de9b35" square_color="#494949" />
                        <Card image="valheim-logo" text1="Valheim" text2="Hvad vi tilbyder" textinfo1="2 GB ram for god start" textinfo2="3 GB ram for en bedre start" textinfo3="5 GB ram for fantastisk start" background_color="#003a49" square_color="#494949"/>
                        <Card image="ark3" text1="ARK: Survival Evolved" text2="Hvad vi tilbyder" textinfo1="2 GB ram for god start" textinfo2="3 GB ram for en bedre start" textinfo3="5 GB ram for fantastisk start" background_color="#786759" square_color="#494949" />
                        <Card image="gmod" text1="Garry's Mod" text2="Hvad vi tilbyder" textinfo1="2 GB ram for god start" textinfo2="3 GB ram for en bedre start" textinfo3="5 GB ram for fantastisk start" background_color="#1194f0" square_color="#494949" />    
                    </div>
                    
                    <div className="whyUs">
                        <div className="containerUs">
                            <div className="row">
                                <div className="whyUsHeader offset-md-2">
                                    <h2 className="titelUs text-center">Why Choose Us</h2>
                                    <p className="UnderText text-center">Novuservers is build to host games with your friends!</p>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-sm-6 col-lg-4">
                                    <div class="box">
                                        <span>01</span>
                                        <h4><a href="#">Security</a></h4>
                                        <p>There are many variations of passages of available, but the majority have suffered alteration in some form</p>
                                        <img src={mc} alt="logo" />
                                    </div>
                                </div>
                            

                            <div class="col-sm-6 col-lg-4">
                                    <div class="box">
                                        <span>02</span>
                                        <h4><a href="#">Prices</a></h4>
                                        <p>There are many variations of Lorem Ipsum available, but the majority have suffered alteration in some form</p>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-lg-4">
                                    <div class="box">
                                        <span>03</span>
                                        <h4><a href="#">Support</a></h4>
                                        <p>There are many variations of Lorem Ipsum available, but the majority have suffered alteration in some form</p>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-lg-4">
                                    <div class="box">
                                        <span>04</span>
                                        <h4><a href="#">Server</a></h4>
                                        <p>There are many variations of passages of Lorem Ipsum available, the majority have suffered alteration in some form</p>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-lg-4">
                                    <div class="box">
                                        <span>05</span>
                                        <h4><a href="#">Fast</a></h4>
                                        <p>There are many of passages of Lorem Ipsum available, but the majority have suffered alteration in some form</p>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-lg-4">
                                    <div class="box">
                                        <span>06</span>
                                        <h4><a href="#">Can I get some</a></h4>
                                        <p>There are variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="faqs">
                        {faqs.map((faq, i) => (
                        <FAQ faq={faq} index={i} toggleFAQ={toggleFAQ} />
                         ))}
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
}

export default App;
